module.exports = {"TXTWCL_Mobile_Number_Verification":{"id":"TXTWCL_Mobile_Number_Verification","defaultMessage":"Верификация на номер на мобилен телефон"}}